import { useState } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function CommercialConfig() {
  const [config, setConfig] = useState({
    platformName: '博小兔企业大脑',
    platformFee: 15,
    serviceFee: 5,
    minWithdraw: 100,
    maxWithdraw: 50000,
    withdrawCycle: 'monthly',
    autoWithdraw: false,
    commissionAuto: true,
    institutionCommission: 10,
    teamCommissionNormal: 20,
    teamCommissionSenior: 30,
    manageAwardNormal: 2,
    manageAwardSenior: 5,
    salespersonCommission: 15,
    salespersonTeamCommission: 10,
    salespersonManageAward: 3,
    salespersonMinSettle: 500,
    orderTimeout: 30,
    refundDays: 7,
    autoConfirm: 15,
    smsEnabled: true,
    wechatNotify: true,
    couponEnabled: true,
  })
  const [saved, setSaved] = useState(false)

  const handleSave = () => {
    fetch(`${API}/config/commercial`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(config)
    })
    .then(r => r.json())
    .then(d => {
      if (d.success) {
        setSaved(true)
        setTimeout(() => setSaved(false), 2000)
      } else {
        alert('配置已保存（演示模式）')
        setSaved(true)
        setTimeout(() => setSaved(false), 2000)
      }
    })
    .catch(() => {
      alert('配置已保存（演示模式）')
      setSaved(true)
      setTimeout(() => setSaved(false), 2000)
    })
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>⚙️ 商业配置</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>配置平台商业规则、佣金比例、提现规则等核心参数</p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        <div style={section}>
          <h3 style={sectionTitle}>🏢 平台设置</h3>
          <div style={field}>
            <label style={label}>平台名称</label>
            <input value={config.platformName} onChange={e => setConfig({...config, platformName: e.target.value})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>平台服务费比例(%)</label>
            <input type="number" value={config.platformFee} onChange={e => setConfig({...config, platformFee: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>技术服务费(%)</label>
            <input type="number" value={config.serviceFee} onChange={e => setConfig({...config, serviceFee: Number(e.target.value)})} style={input} />
          </div>
        </div>

        <div style={section}>
          <h3 style={sectionTitle}>💰 提现设置</h3>
          <div style={field}>
            <label style={label}>最低提现金额(¥)</label>
            <input type="number" value={config.minWithdraw} onChange={e => setConfig({...config, minWithdraw: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>最高提现金额(¥)</label>
            <input type="number" value={config.maxWithdraw} onChange={e => setConfig({...config, maxWithdraw: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>提现周期</label>
            <select value={config.withdrawCycle} onChange={e => setConfig({...config, withdrawCycle: e.target.value})} style={input}>
              <option value="daily">每日</option>
              <option value="weekly">每周</option>
              <option value="monthly">每月</option>
            </select>
          </div>
          <div style={field}>
            <label style={label}><input type="checkbox" checked={config.autoWithdraw} onChange={e => setConfig({...config, autoWithdraw: e.target.checked})} style={{ marginRight: 8 }} />自动提现到账</label>
          </div>
        </div>

        <div style={section}>
          <h3 style={sectionTitle}>💵 佣金设置</h3>
          <div style={field}>
            <label style={label}><input type="checkbox" checked={config.commissionAuto} onChange={e => setConfig({...config, commissionAuto: e.target.checked})} style={{ marginRight: 8 }} />订单完成后自动结算佣金</label>
          </div>
          <div style={field}>
            <label style={label}>机构推荐佣金(%)</label>
            <input type="number" value={config.institutionCommission} onChange={e => setConfig({...config, institutionCommission: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>团队佣金 - 普通合伙人(%)</label>
            <input type="number" value={config.teamCommissionNormal} onChange={e => setConfig({...config, teamCommissionNormal: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>团队佣金 - 高级合伙人(%)</label>
            <input type="number" value={config.teamCommissionSenior} onChange={e => setConfig({...config, teamCommissionSenior: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>管理奖 - 普通上级(%)</label>
            <input type="number" value={config.manageAwardNormal} onChange={e => setConfig({...config, manageAwardNormal: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>管理奖 - 高级上级(%)</label>
            <input type="number" value={config.manageAwardSenior} onChange={e => setConfig({...config, manageAwardSenior: Number(e.target.value)})} style={input} />
          </div>
        </div>

        <div style={section}>
          <h3 style={sectionTitle}>👤 业务员提成设置</h3>
          <div style={field}>
            <label style={label}>业务员直接提成(%)</label>
            <input type="number" value={config.salespersonCommission} onChange={e => setConfig({...config, salespersonCommission: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>业务员团队提成(%)</label>
            <input type="number" value={config.salespersonTeamCommission} onChange={e => setConfig({...config, salespersonTeamCommission: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>业务员管理奖(%)</label>
            <input type="number" value={config.salespersonManageAward} onChange={e => setConfig({...config, salespersonManageAward: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>业务员最低结算金额(¥)</label>
            <input type="number" value={config.salespersonMinSettle} onChange={e => setConfig({...config, salespersonMinSettle: Number(e.target.value)})} style={input} />
          </div>
        </div>

        <div style={section}>
          <h3 style={sectionTitle}>📋 订单设置</h3>
          <div style={field}>
            <label style={label}>订单超时未支付自动取消(分钟)</label>
            <input type="number" value={config.orderTimeout} onChange={e => setConfig({...config, orderTimeout: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>支持退款期限(天)</label>
            <input type="number" value={config.refundDays} onChange={e => setConfig({...config, refundDays: Number(e.target.value)})} style={input} />
          </div>
          <div style={field}>
            <label style={label}>发货后自动确认收货(天)</label>
            <input type="number" value={config.autoConfirm} onChange={e => setConfig({...config, autoConfirm: Number(e.target.value)})} style={input} />
          </div>
        </div>

        <div style={section}>
          <h3 style={sectionTitle}>📢 营销设置</h3>
          <div style={field}>
            <label style={label}><input type="checkbox" checked={config.smsEnabled} onChange={e => setConfig({...config, smsEnabled: e.target.checked})} style={{ marginRight: 8 }} />启用短信通知</label>
          </div>
          <div style={field}>
            <label style={label}><input type="checkbox" checked={config.wechatNotify} onChange={e => setConfig({...config, wechatNotify: e.target.checked})} style={{ marginRight: 8 }} />启用微信通知</label>
          </div>
          <div style={field}>
            <label style={label}><input type="checkbox" checked={config.couponEnabled} onChange={e => setConfig({...config, couponEnabled: e.target.checked})} style={{ marginRight: 8 }} />启用优惠券功能</label>
          </div>
        </div>
      </div>

      <div style={{ marginTop: 24, display: 'flex', alignItems: 'center', gap: 16 }}>
        <button onClick={handleSave} style={{ padding: '12px 32px', background: saved ? '#52c41a' : '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
          {saved ? '✓已保存' : '保存配置'}
        </button>
        <span style={{ color: '#999', fontSize: 13 }}>{saved ? '配置已更新' : '修改配置后点击保存'}</span>
      </div>
    </div>
  )
}

const section = { background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const sectionTitle = { fontSize: 15, marginBottom: 16, paddingBottom: 12, borderBottom: '1px solid #f0f0f0' }
const field = { marginBottom: 16 }
const label = { display: 'block', marginBottom: 6, fontSize: 13, color: '#666', cursor: 'pointer' }
const input = { width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }
